import { httpClient, type RequestOptions } from "./http-client";
import type {
  OtpSendResponse,
  OtpVerifyResponse,
  AuthMeResponse,
  RegisterBusinessRequest,
} from "~/types/api";
import type { Phone } from "~/types/entities";

const LOGIN_REQUEST: RequestOptions = { redirectOnUnauthorized: false };

export function sendOtp(phone: Phone) {
  return httpClient.post<OtpSendResponse>(
    "/auth/send-otp",
    { phone },
    LOGIN_REQUEST,
  );
}

export function verifyOtp(challengeId: string, verificationCode: string) {
  return httpClient.post<OtpVerifyResponse>(
    "/auth/verify-otp",
    {
      challengeId,
      verificationCode,
    },
    LOGIN_REQUEST,
  );
}

export function resendOtp(challengeId: string) {
  return httpClient.post<OtpSendResponse>(
    "/auth/resend-otp",
    {
      challengeId,
    },
    LOGIN_REQUEST,
  );
}

export function registerBusiness(data: RegisterBusinessRequest) {
  return httpClient.post<OtpVerifyResponse>(
    "/auth/register-business",
    data,
    LOGIN_REQUEST,
  );
}

export function getMe() {
  return httpClient.get<AuthMeResponse>("/auth/me");
}
